var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50354 15C11.6163 15 15 11.6163 15 7.50354C15 3.38367 11.6163 0 7.49646 0C3.37659 0 0 3.38367 0 7.50354C0 11.6163 3.38367 15 7.50354 15ZM5.31619 6.77442C4.86314 6.77442 4.49504 6.37093 4.49504 5.81878C4.49504 5.25248 4.86314 4.85606 5.31619 4.85606C5.76215 4.85606 6.14441 5.25248 6.14441 5.81878C6.14441 6.37093 5.76215 6.77442 5.31619 6.77442ZM9.69797 6.77442C9.23785 6.77442 8.86975 6.37093 8.86975 5.81878C8.86975 5.25248 9.23785 4.85606 9.69797 4.85606C10.1439 4.85606 10.5333 5.25248 10.5333 5.81878C10.5333 6.37093 10.1439 6.77442 9.69797 6.77442ZM4.82775 9.47145C4.82775 9.28032 5.01888 9.1883 5.20293 9.27324C5.76215 9.55639 6.39217 9.88202 7.49646 9.88202C8.60075 9.88202 9.22369 9.54932 9.79 9.27324C9.97404 9.1883 10.1652 9.28032 10.1652 9.47145C10.1652 9.98112 9.09627 11.0429 7.49646 11.0429C5.89665 11.0429 4.82775 9.98112 4.82775 9.47145Z",
    fill: "#F5F7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyFace);
export default __webpack_public_path__ + "static/media/icon-smiley-face.0fa07164ed4d975f6168a0fd1f66a0db.svg";
export { ForwardRef as ReactComponent };